import React, { useContext } from "react";
import { Card, List, Space, Tag } from "antd";
import {
  renderOverbookedIcon,
  renderStatusIcon,
} from "../../../quick-report/helpers/renderStatusIcon";
import TextBody from "../../../../app/system-components/typography/text/TextBody";
import {
  COLOR_BLUE_0,
  COLOR_DARK_BG_0,
  COLOR_GREEN_0,
  COLOR_LIGHT_GRAY,
  COLOR_PURPLE_0,
  COLOR_TEXT_GRAY_0,
  COLOR_TEXT_GRAY_1,
  COLOR_TEXT_GRAY_2,
} from "../../../../app/ui/colorConstants";
import { SalesReportContext } from "../SalesReport";
import NumberFormat from "react-number-format";
import {
  ItemTag,
  ItemTagWithBg,
} from "../../../../app/system-components/tags/Tags";
import { ROW_TYPE_SUBTOTAL } from "../../../../app/utils/models/modelConstants/modelConstants";
import { Link } from "react-router-dom";
import { ROUTE_EDIT_INVOICE } from "../../../../app/routes";

const SalesInvoices = () => {
  const { state, actions } = useContext(SalesReportContext);
  return (
    <Card size={"small"}>
      <List
        header={"Invoices"}
        itemLayout="horizontal"
        dataSource={state.filteredInvoices}
        renderItem={(item) => (
          <List.Item
            extra={
              <Space>
                Invoice Total:{" "}
                <NumberFormat
                  value={item?.total?.toFixed(2)}
                  displayType={"text"}
                  thousandSeparator={true}
                  prefix={"$"}
                />
              </Space>
            }
            // onClick={() => setSelectedInvoice(item)}
          >
            <List.Item.Meta
              title={
                <Link
                  to={`${ROUTE_EDIT_INVOICE}${item?.id}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <TextBody
                    text={`#${item?.invoiceNumber}: ${item?.customer?.customerDisplayName}`}
                  />
                </Link>
              }
              description={
                <Space>
                  {item?.selectedItems?.items?.map((i) => {
                    if (i?.rowType === ROW_TYPE_SUBTOTAL) return null;
                    const isSelected = state.selectedInvItem === i?.id;
                    return (
                      <div>
                        <Tag
                          style={{
                            borderColor: "transparent",
                            margin: "4px",
                            background: isSelected
                              ? COLOR_BLUE_0
                              : COLOR_LIGHT_GRAY,
                            color: isSelected ? "#FFF" : COLOR_DARK_BG_0,
                          }}
                        >
                          <span
                            style={{
                              fontWeight: "bold",
                            }}
                          >
                            ({i?.selectedQty})
                          </span>{" "}
                          {i?.name}
                        </Tag>
                      </div>
                    );
                  })}
                </Space>
              }
            />
          </List.Item>
        )}
      />
    </Card>
  );
};

export default SalesInvoices;
